<template>
  <div>
    <!-- 头部 -->

    <Head></Head>
    <div class="user">
      <!-- 用户中心头部 -->
      <div class="w">
        <div class="user-head">
          <!-- 头像 -->
          <div class="pic">
            <img :src="userInfo.data.pic" alt />
            <a href="javascript:;" @click="changeDialogVisible = true">变更</a>
          </div>
          <!-- 用户名 -->
          <div class="user-name">
            <div>
              <p>ID:{{ userInfo.data.id }}</p>
              <h6>{{ userInfo.data.realname }} 様</h6>
            </div>
          </div>
          <!--余额  -->
          <div class="account">
            <img src="../../assets/img/user_home/coupon.png" alt="" />
            <span>残高</span>
            <b>{{ money }}</b>
            円
            <router-link to="/user/golden">チャージ>></router-link>
          </div>
        </div>
      </div>
    </div>

    <div class="w mian">
      <!-- 侧边导航 -->
      <div class="sidebar" @click="bgcolor">
        <!-- 订单管理 -->
        <div class="new-order">
          <a href="javascript:;" @click="$router.push('/zhuwen')">新規注文</a>
          <img src="../../assets/img/user_home/picture-1.png" alt="" />
        </div>
        <!-- 用户首页 -->
        <div class="new-order" style="background: linear-gradient(225deg, #ffffff 0%, #fff9e2 100%)">
          <a href="javascript:;" @click="$router.push('/user/index')">トップページへ</a>
          <img src="../../assets/img/user_home/picture-2.png" alt="" />
        </div>
        <!-- 导航 -->
        <div class="nav">
          <dl>
            <dt>
              <a href="javascript:;">
                <i class="el-icon-tickets"></i> オーダー管理</a>
            </dt>
            <dd :class="{ isBgc: bgc == 0 }" @click="bgc = 0">
              <router-link to="/user/proceedOrder">代行注文書({{ orderData.order }})</router-link>
            </dd>
            <dd :class="{ isBgc: bgc == 14 }" @click="bgc = 14">
              <router-link to="/user/productState">臨時メニュー({{ orderData.order }})</router-link>
            </dd>
            <dd>
              <router-link to="/excelZhuwen" target="_blank">
                エクセルで注文</router-link>
            </dd>
            <dd :class="{ isBgc: bgc == 1 }" @click="bgc = 1">
              <router-link to="/user/domesticLogistics">中国国内物流状態({{ orderData.logistic }})</router-link>
            </dd>
            <dd :class="{ isBgc: bgc == 2 }" @click="bgc = 2">
              <router-link to="/user/warehouse">倉庫·配送依頼({{ orderData.warehouse }})</router-link>
            </dd>
            <dd :class="{ isBgc: bgc == 3 }" @click="bgc = 3">
              <router-link to="/user/deliverOrder">配送依頼({{ orderData.porder }})</router-link>
            </dd>
            <dd :class="{ isBgc: bgc == 15 }" @click="bgc = 15">
              <router-link to="/issueProduct" target="_blank">
                問題商品 ({{ orderData.problemCount }})</router-link>
            </dd>
          </dl>
          <dl>
            <dt>
              <a href="javascript:;">
                <i class="el-icon-star-off"></i> お気に入り</a>
            </dt>
            <!-- <dd :class="{isBgc:bgc==4}" @click="bgc=4">
            <router-link to="/user/merchandise">商品庫</router-link>
          </dd> -->
            <dd :class="{ isBgc: bgc == 5 }" @click="bgc = 5">
              <router-link to="/user/newCommodity">お気に入り商品({{ orderData.favorite }})</router-link>
            </dd>
            <dd :class="{ isBgc: bgc == 6 }" @click="bgc = 6">
              <router-link to="/user/favoriteShop">お気に入り店舗</router-link>
            </dd>
            <dd v-if="userInfo.data.id == 71 || userInfo.data.id == 50 || userInfo.data.id == 318230">
              <a href="https://www.rakumart-2c.com/client_product/#/productList" target="_blank">商品库</a>
            </dd>
          </dl>
          <!-- 收藏 -->
          <dl>
            <dt>
              <a href="javascript:;">
                <i class="el-icon-reading"></i> 出入金管理</a>
            </dt>
            <dd :class="{ isBgc: bgc == 7 }" @click="bgc = 7">
              <router-link to="/user/golden">新規入金</router-link>
            </dd>
            <dd :class="{ isBgc: bgc == 8 }" @click="bgc = 8">
              <router-link to="/user/goldenRecord">入出金履歴</router-link>
            </dd>
          </dl>
          <!-- 个人情报管理 -->
          <dl>
            <dt>
              <a href="javascript:;">
                <i class="el-icon-setting"></i> 個人情報管理</a>
            </dt>
            <dd :class="{ isBgc: bgc == 9 }" @click="bgc = 9">
              <router-link to="/user/personalDetails">登録情報</router-link>
            </dd>
            <!-- <dd :class="{ isBgc: bgc == 10 }" @click="bgc = 10">
            <router-link to="/user/LoginMessage">授权管理</router-link>
          </dd>
          <dd :class="{ isBgc: bgc == 11 }" @click="bgc = 11">
            <router-link to="/user/sonAccount">社員用アカウント</router-link>
          </dd> -->
            <dd :class="{ isBgc: bgc == 12 }" @click="bgc = 12">
              <router-link to="/user/site">配送先管理</router-link>
            </dd>
            <dd :class="{ isBgc: bgc == 13 }" @click="bgc = 13">
              <router-link to="/user/changPssword">パスワード変更</router-link>
            </dd>
             <dd :class="{ isBgc: bgc == 16 }" @click="bgc = 16">
              <router-link to="/user/urlUpload">URLアップロード</router-link>
            </dd>
          </dl>
        </div>
      </div>
      <!-- 组件内容 -->
      <div class="components fl">
        <router-view></router-view>
      </div>
    </div>
    <!--  更换头像 -->
    <el-dialog :visible.sync="changeDialogVisible" width="350px" center>
      <div class="user-img">
        <img :src="changeImg" class="avatar" v-if="changeImg" />
        <img :src="userInfo.data.pic" class="avatar" v-else />
      </div>
      <el-upload class="upload-demo" ref="upload" action accept=".jpg, .jpeg, .png, .JPG, .JPEG" :auto-upload="false"
        :on-change="getFile">
        <el-button style="margin-left: 10px" size="small" type="success" @click="submitUpload">アップロード
        </el-button>
        <el-button slot="trigger" size="small" type="primary">ファイルを選択
        </el-button>
        <div slot="tip" class="el-upload__tip">ファイル最大サイズ500kbまで</div>
      </el-upload>
    </el-dialog>
    <!-- 尾部 -->
    <Foot></Foot>
  </div>
</template>
<script>
import Head from "../../components/head/Head";
import Foot from "../../components/foot/Foot";
import { mapState, mapMutations } from "vuex";
import { submitUpload, money, menuCount } from "../../api/API/user";
export default {
  data() {
    return {
      changeImg: "",
      changeDialogVisible: false,
      money: 0,
      bgc: -1,
      orderData: {}, // 获取个人中心首页各项统计
    };
  },
  components: {
    Head,
    Foot,
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  created() {
    this.getMoney();
    this.menuCount();
  },
  mounted() {
    this.bgcolor();
  },
  methods: {
    ...mapMutations(["changePicture"]),
    // 金额 余额
    getMoney() {
      money().then((res) => {
        this.money = res.data;
      });
    },
    // 获取列表数量
    menuCount() {
      menuCount().then((res) => {
        this.orderData = res.data;
      });
    },
    getFile(file, fileList) {
      this.changeImg = URL.createObjectURL(file.raw);
      this.getBase64(file.raw).then((res) => {
        this.imageBase = res;
      });
    },
    // 转换base 64位
    getBase64(file) {
      return new Promise(function (resolve, reject) {
        let reader = new FileReader();
        let imgResult = "";
        reader.readAsDataURL(file);
        reader.onload = function () {
          imgResult = reader.result;
        };
        reader.onerror = function (error) {
          reject(error);
        };
        reader.onloadend = function () {
          resolve(imgResult);
        };
      });
    },
    // 更换头像
    submitUpload() {
      submitUpload({ image: this.imageBase }).then((res) => {
        if (res.code != 1) return this.$message.error("画像変更完了しました");
        this.changePicture(res.data);
        this.$message.success("画像変更完了しました");
        this.changeDialogVisible = false;
      });
    },
    // 提示导航背景
    bgcolor() {
      if (this.$route.name == "proceedOrder") {
        this.bgc = 0;
      } else if (this.$route.name == "domesticLogistics") {
        this.bgc = 1;
      } else if (this.$route.name == "warehouse") {
        this.bgc = 2;
      } else if (this.$route.name == "deliverOrder") {
        this.bgc = 3;
      } else if (this.$route.name == "merchandise") {
        this.bgc = 4;
      } else if (this.$route.name == "newCommodity") {
        this.bgc = 5;
      } else if (this.$route.name == "favoriteShop") {
        this.bgc = 6;
      } else if (this.$route.name == "golden") {
        this.bgc = 7;
      } else if (this.$route.name == "goldenRecord") {
        this.bgc = 8;
      } else if (this.$route.name == "personalDetails") {
        this.bgc = 9;
      } else if (this.$route.name == "LoginMessage") {
        this.bgc = 10;
      } else if (this.$route.name == "sonAccount") {
        this.bgc = 11;
      } else if (this.$route.name == "site") {
        this.bgc = 12;
      } else if (this.$route.name == "changPssword") {
        this.bgc = 13;
      } else if (this.$route.name == "urlUpload") {
        this.bgc = 16;
      } else if (this.$route.name == "index") {
        this.bgc = -1;
      } else {
        this.bgc = -2;
      }
      //   console.log(this.$route.name);
    },
  },
};
</script>
<style>
body {
  background-color: #f9f9f9;
}
</style>
<style lang='scss' scoped>
.user-head {
  padding: 21px;
  background-color: #fff;
  margin: 20px 0;
  display: flex;
  flex-wrap: wrap;
  position: relative;

  .pic {
    position: relative;

    &:hover a {
      display: block;
    }

    img {
      height: 118px;
      width: 118px;
      border-radius: 50%;
      margin-right: 21px;
    }

    a {
      position: absolute;
      top: 0;
      left: 0;
      height: 118px;
      width: 118px;
      border-radius: 50%;

      background: rgba($color: #000000, $alpha: 0.3);
      text-align: center;
      line-height: 118px;
      font-size: 25px;
      color: #fff;
      display: none;
    }
  }

  .user-name {
    display: flex;
    align-items: center;
    font-size: 20px;
  }

  .account {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    line-height: 40px;
    // height: 30px;
    display: flex;
    flex-wrap: wrap;

    img {
      width: 30px;
      height: 30px;
      margin-right: 10px;

      vertical-align: middle;
      transform: translate(0, 4px);
    }

    span {
      font-size: 20px;
      margin-right: 20px;
    }

    b {
      color: #b7040b;
      font-size: 30px;
      margin-right: 10px;
    }

    a {
      display: inline-block;
      width: 120px;
      height: 40px;
      text-align: center;
      line-height: 40px;

      color: #333;

      background-color: #f3c622;
      margin-left: 30px;
      font-size: 16px;
      border-radius: 2px;
    }
  }
}

.mian {
  overflow: hidden;
  margin-bottom: 30px;
  display: flex;

  .sidebar {
    flex: 1.3;
    margin-right: 20px;

    .new-order {
      margin-bottom: 10px;
      background: linear-gradient(225deg, #ffffff 0%, #ffeded 100%);
      position: relative;

      a {
        display: block;
        height: 64px;

        line-height: 64px;
        font-size: 16px;
        padding-left: 20px;

        color: #222;
        position: relative;
        z-index: 9;
      }

      img {
        position: absolute;
        top: 0;
        right: 0;
        height: 64px;
      }
    }

    .nav {
      background-color: #fff;
    }

    dl {
      margin-bottom: 10px;

      dt {
        a {
          display: block;

          height: 40px;
          padding-left: 20px;
          font-size: 14px;
          font-weight: 700;
          color: #333;
          text-align: left;
          line-height: 40px;
        }

        i {
          font-size: 18px;
        }
      }

      dd {
        a {
          border-left: 4px solid transparent;
          display: block;
          padding-left: 16px;
          height: 40px;
          font-size: 14px;
          text-align: left;
          line-height: 40px;
          color: #666;
          border-top: 0;
        }

        &:hover {
          background: #fcf3d3;

          a {
            border-color: #f3c622;
          }
        }
      }

      .isBgc {
        background: #fcf3d3;

        a {
          border-color: #f3c622;
        }
      }
    }
  }

  .components {
    flex: 9;
    background-color: #fff;
  }
}

.user-img {
  width: 300px;
  height: 300px;
  margin: 0 auto 20px;

  img {
    width: 100%;
    height: 100%;
  }
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
